// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_7852ba31","outerContainer":"_2f0c4afd","secondaryToolbar":"_56b2f2de","doorHangerRight":"_069b6189","toolbarContainer":"b9e58388","toolbarViewerMiddle":"_332e021e","progressBar":"_3aa2c4ba","back-to-application":"d0cfc788","root":"_495f1c8c","leftSideWrapper":"c365deb7","avatar":"_13c3425d","description":"_6756b474","date":"_65445967","actionButton":"_08a55dc0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/ActivityLog/index.styl
// module id = 5045
// module chunks = 39